export type { SplitTextProps } from "./split-text";
export { SplitText } from "./split-text";
